// extracted by mini-css-extract-plugin
export default {"homeContainer":"Home_homeContainer__Ir6hJ","downloadIcon":"Home_downloadIcon__IDef7","bounce":"Home_bounce__Ze6aC"};